// extracted by mini-css-extract-plugin
export default {"filter":"FilterMenuWrapper_filter__6-IlM"};